import React, { FunctionComponent } from "react";

// Bluesky Streamline Icon: https://streamlinehq.com
// https://www.streamlinehq.com/icons/download/bluesky--29494
const BlueskyLogoIcon: FunctionComponent = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 576 576"
      id="Bluesky--Streamline-Font-Awesome"
    >
      <path
        d="M405.404 325.9411c-3.234 -0.392 -6.566 -0.784 -9.8 -1.274 3.332 0.392 6.566 0.882 9.8 1.274ZM288 259.6931c-25.578 -49.686 -95.158 -142.296 -159.838 -187.964 -62.034 -43.806 -85.652 -36.26 -101.234 -29.204C8.994 50.6591 5.76 78.1971 5.76 94.3671s8.918 132.888 14.7 152.39c19.11 64.386 87.318 86.142 150.136 79.086 3.234 -0.49 6.468 -0.882 9.8 -1.372 -3.234 0.49 -6.468 0.98 -9.8 1.372 -92.022 13.72 -173.754 47.236 -66.542 166.502 117.894 122.108 161.504 -26.166 183.946 -101.332 22.442 75.166 48.216 218.05 181.888 101.332 100.352 -101.332 27.538 -152.88 -64.484 -166.502 -3.234 -0.392 -6.566 -0.784 -9.8 -1.274 3.332 0.392 6.566 0.882 9.8 1.274 62.818 6.958 130.928 -14.798 150.136 -79.086 5.782 -19.502 14.7 -136.122 14.7 -152.39s-3.234 -43.806 -21.168 -51.842c-15.484 -6.958 -39.2 -14.602 -101.136 29.204 -64.778 45.668 -134.358 138.278 -159.936 187.964Z"
        fill="currentColor"
      ></path>
    </svg>
  );
};

export default BlueskyLogoIcon;
